import {
  Input,
  Box,
  Text,
  VStack,
  HStack,
  Stack,
  InputGroup,
  InputLeftAddon,
} from "@chakra-ui/react";
import { Controller, useForm } from "react-hook-form";
import { StepProps } from "./CreateCampaignWizard";
import { Navigation } from "./Navigation";
import { Select } from "chakra-react-select";
import WhiteBgInput from "./WhiteBgInput";

const CampaignForm = ({
  onCreateCampaign,
  adAccounts = [],
  campaign,
  loading,
  back,
}: StepProps) => {
  console.log({
    adAccounts,
  });

  const { register, control, watch, setValue, handleSubmit } = useForm({
    values: {
      id: campaign?.id,
      name: campaign?.name.replace("KYD: ", ""),
      campaign_type: campaign?.campaign_type,
      ad_account: campaign?.ad_account_id
        ? {
            value: campaign.ad_account_id,
            label: adAccounts?.find((a) => a.id === campaign.ad_account_id)
              ?.name,
          }
        : {
            value: adAccounts?.at(0)?.id,
            label: adAccounts?.at(0)?.name,
          },
    },
  });

  const _onSubmit = async (data: any) => {
    return onCreateCampaign(data);
  };

  const isEdit = !!campaign?.id;

  const isValid =
    watch(`name`)?.length > 0 && watch(`campaign_type`) !== undefined;

  return (
    <VStack w="full">
      <VStack w="full">
        <Stack w="full" spacing={8} direction={["column", "row"]}>
          <VStack w="full" h="full" spacing={2} p={2}>
            <Text
              w="full"
              fontSize={"large"}
              fontWeight={"bold"}
              textAlign={"left"}
            >
              Ad Account (*)
            </Text>
            {isEdit ? (
              <WhiteBgInput
                isDisabled
                placeholder="Ad Account"
                value={`${
                  adAccounts?.find((a) => a.id === campaign?.ad_account_id)
                    ?.name
                } (${campaign?.ad_account_id})`}
              />
            ) : (
              <Controller
                control={control}
                name="ad_account"
                disabled={isEdit}
                rules={{ required: true }}
                render={({ field }) => (
                  <Select
                    isDisabled={loading.campaigns || loading.adaccounts}
                    value={field.value}
                    defaultValue={field.value}
                    onChange={(values) => field.onChange(values)}
                    chakraStyles={{
                      container: () => ({
                        position: "relative",
                        width: "100%",
                        backgroundColor: "white",
                      }),
                    }}
                    // @ts-ignore
                    options={adAccounts?.map((a) => ({
                      label: `${a.name} (${a.id})`,
                      value: a.id,
                    }))}
                  />
                )}
              />
            )}
            <Text
              w="full"
              fontSize={"large"}
              fontWeight={"bold"}
              textAlign={"left"}
            >
              Campaign Name (*)
            </Text>
            <Box w="full">
              <InputGroup>
                <InputLeftAddon>KYD: </InputLeftAddon>
                <WhiteBgInput
                  isDisabled={loading.campaigns}
                  placeholder="Name"
                  borderTopLeftRadius={0}
                  borderBottomLeftRadius={0}
                  {...register(`name`, { required: true })}
                />
              </InputGroup>
            </Box>
            <Box w="full">
              <Text fontSize={"xs"} color="gray.400" w="full">
                This name will be used to identify the campaign in the Facebook
                Ads Manager
              </Text>
            </Box>
          </VStack>
          <VStack h="full" p={2} spacing={4}>
            <Text
              w="full"
              fontSize={"large"}
              fontWeight={"bold"}
              textAlign={"left"}
            >
              Goal (*)
            </Text>
            <HStack
              gap={2}
              opacity={loading.campaigns || isEdit ? 0.5 : 1}
              pointerEvents={loading.campaigns || isEdit ? "none" : "auto"}
            >
              <Box
                flex={1}
                aspectRatio={1}
                onClick={() =>
                  !isEdit ? setValue(`campaign_type`, "conversion") : undefined
                }
                backgroundColor={
                  watch(`campaign_type`) === "conversion" ? "gray.100" : "white"
                }
                borderRadius={"lg"}
                p={4}
                borderWidth={2}
                borderColor={
                  watch(`campaign_type`) === "conversion"
                    ? "green.500"
                    : "gray.200"
                }
              >
                <Text fontWeight={"bold"}>Sales Campaign</Text>
                <Text fontSize={"xs"} color="gray.400">
                  Sales Campaign is a campaign that will be used to create
                  ticket sales
                </Text>
              </Box>
              <Box
                flex={1}
                aspectRatio={1}
                onClick={() =>
                  !isEdit ? setValue(`campaign_type`, "awareness") : undefined
                }
                backgroundColor={
                  watch(`campaign_type`) === "awareness" ? "gray.100" : "white"
                }
                borderRadius={"lg"}
                p={4}
                borderWidth={2}
                borderColor={
                  watch(`campaign_type`) === "awareness"
                    ? "green.500"
                    : "gray.200"
                }
              >
                <Text fontWeight={"bold"}>Awareness Campaign</Text>
                <Text fontSize={"xs"} color="gray.400">
                  Awareness Campaign is a campaign that will be used to increase
                  the visibility of your event
                </Text>
              </Box>
            </HStack>
          </VStack>
        </Stack>
      </VStack>
      <Navigation
        isLoading={loading.campaigns || loading.adaccounts}
        back={back}
        next={handleSubmit(_onSubmit)}
        nextLabel={campaign ? "Save" : "Create campaign"}
        canNext={isValid}
      />
    </VStack>
  );
};

export default CampaignForm;
